'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-checkbox-button',
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnCheckbox = "".concat(CLASSNAME, "__checkbox"),
    cnContentCheckbox = "".concat(CLASSNAME, "__content-checkbox"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnSelected = "".concat(CLASSNAME, "--selected");
/**
 * 
 * @param {*} param0 
 */

function CheckboxButton(_ref) {
  var className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      name = _ref.name,
      _onChange = _ref.onChange,
      required = _ref.required,
      selected = _ref.selected,
      title = _ref.title,
      value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnDisabled, disabled))
  }, /*#__PURE__*/React__default.createElement("label", {
    className: cnLabel
  }, /*#__PURE__*/React__default.createElement("input", {
    required: required,
    disabled: disabled,
    checked: selected,
    defaultChecked: defaultChecked,
    name: name,
    className: cnCheckbox,
    type: "checkbox",
    onChange: function onChange(e) {
      _onChange(value, e.target.checked);
    },
    value: value
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnContentCheckbox, _rollupPluginBabelHelpers.defineProperty({}, cnSelected, selected))
  }, /*#__PURE__*/React__default.createElement(MaterialDrop, null), /*#__PURE__*/React__default.createElement("span", {
    className: classNames(cnTitle, _rollupPluginBabelHelpers.defineProperty({}, cnSelected, selected))
  }, title))));
}
CheckboxButton.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** True if is initially checked */
  defaultChecked: PropTypes.bool,

  /** True if button is disabled */
  disabled: PropTypes.bool,

  /** Name for form */
  name: PropTypes.string,

  /** Callback function onChange */
  onChange: PropTypes.func,

  /** True if is required in form */
  required: PropTypes.bool,

  /** Boolean to control selected status of button */
  selected: PropTypes.bool,

  /** Title of button */
  title: PropTypes.string.isRequired,

  /** Value of button in form */
  value: PropTypes.string.isRequired
};
CheckboxButton.defaultProps = {
  onChange: function onChange() {
    return void 0;
  }
};

module.exports = CheckboxButton;
